import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { consumePkce } from "../api/pkce";
import { tokenStore, type TokenSet } from "../api/token";

const AUTH_URL = import.meta.env.VITE_AUTH_URL ?? "https://auth-v2.gildiya7.ru";
const CLIENT_ID = import.meta.env.VITE_AUTH_CLIENT_ID ?? "lplanner";
const REDIRECT_URI =
  import.meta.env.VITE_REDIRECT_URI ?? `${window.location.origin}/callback`;

export function CallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const returnedState = params.get("state");
      const oauthError = params.get("error");
      const oauthErrorDesc = params.get("error_description");

      const { state, codeVerifier, returnTo } = consumePkce();

      if (oauthError) {
        if (cancelled) return;
        setError(oauthErrorDesc || oauthError);
        return;
      }
      if (!code || !returnedState) {
        if (cancelled) return;
        setError("В callback не пришёл code/state — попробуйте войти заново.");
        return;
      }
      if (!state || !codeVerifier) {
        if (cancelled) return;
        setError("Сессия входа потерялась (sessionStorage пуст) — войдите заново.");
        return;
      }
      if (state !== returnedState) {
        if (cancelled) return;
        setError("state mismatch — подозрение на CSRF. Войдите заново.");
        return;
      }

      try {
        const res = await fetch(`${AUTH_URL}/oauth/token`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            grant_type: "authorization_code",
            client_id: CLIENT_ID,
            redirect_uri: REDIRECT_URI,
            code,
            code_verifier: codeVerifier,
          }),
        });
        if (!res.ok) {
          let detail = `HTTP ${res.status}`;
          try {
            const body = await res.json();
            detail = body?.error_description || body?.error || detail;
          } catch {
            /* not JSON */
          }
          if (!cancelled) setError(`Не удалось обменять code: ${detail}`);
          return;
        }
        const tokens = (await res.json()) as TokenSet;
        if (!tokens.id_token || !tokens.refresh_token) {
          if (!cancelled) setError("Auth-сервис не вернул id_token/refresh_token.");
          return;
        }
        tokenStore.set(tokens);
        if (cancelled) return;
        const dest = returnTo && returnTo.startsWith("/") ? returnTo : "/";
        navigate(dest, { replace: true });
      } catch (e) {
        if (!cancelled) {
          setError(
            e instanceof Error ? e.message : "Сеть не дошла до auth-сервиса.",
          );
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="auth-splash">
      <div className="auth-splash-card">
        <div className="auth-splash-title">
          {error ? "Не удалось войти" : "Готовим сессию…"}
        </div>
        {error && (
          <div className="auth-splash-sub">
            {error}
            <br />
            <a href="/login">Попробовать ещё раз</a>
          </div>
        )}
      </div>
    </div>
  );
}
